export default [
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/admin/Admin.vue'),
        redirect: '/admin/subjects/list',
        children: [
            {
                path: '/admin/translation-config',
                name: 'admin-translation-config',
                component: () => import('@/views/admin/translation-config/TranslationConfig.vue'),
            },
            // CRUD USER
            {
                path: '/admin/user',
                name: 'admin-user',
                redirect: '/admin/user/list',
                props: true,
                component: () => import('@/views/admin/users/User.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-user-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/users/UserList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-user-register',
                        component: () => import('@/views/admin/users/UserRegister.vue'),
                        navActiveLink: 'admin-user',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-user-register-update',
                        component: () => import('@/views/admin/users/UserRegister.vue'),
                        navActiveLink: 'admin-user-register',
                    },
                ]
            },

            // CRUD USER CLIENT
            {
                path: '/admin/user-client',
                name: 'admin-user-client',
                redirect: '/admin/user-client/list',
                props: true,
                component: () => import('@/views/admin/user-client/UserClient.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-user-client-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/user-client/UserClientList.vue'),
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-user-client-register-update',
                        component: () => import('@/views/admin/user-client/UserClientRegister.vue'),
                        navActiveLink: 'admin-user-client-register',
                    },
                ]
            },

            // CRUD SUBJECTS
            {
                path: '/admin/subjects',
                name: 'admin-subject',
                redirect: '/admin/subjects/list',
                props: true,
                component: () => import('@/views/admin/subjects/Subject.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-subject-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/subjects/SubjectList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-subject-register',
                        component: () => import('@/views/admin/subjects/SubjectRegister.vue'),
                        navActiveLink: 'admin-subject',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-subject-register-update',
                        component: () => import('@/views/admin/subjects/SubjectRegister.vue'),
                        navActiveLink: 'admin-subject-register',
                    },
                ]
            },

            // CRUD USER HEADER
            {
                path: '/admin/user-header',
                name: 'admin-user-header',
                redirect: '/admin/user-header/list',
                props: true,
                component: () => import('@/views/admin/user-header/UserHeader.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-user-header-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/user-header/UserHeaderList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-user-header-register',
                        component: () => import('@/views/admin/user-header/UserHeaderRegister.vue'),
                        navActiveLink: 'admin-user-header',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-user-header-register-update',
                        component: () => import('@/views/admin/user-header/UserHeaderRegister.vue'),
                        navActiveLink: 'admin-user-header-register',
                    },
                ]
            },

            // CRUD TAGS
            {
                path: '/admin/tags',
                name: 'admin-tag',
                redirect: '/admin/tags/list',
                props: true,
                component: () => import('@/views/admin/tags/Tag.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-tag-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/tags/TagList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-tag-register',
                        component: () => import('@/views/admin/tags/TagRegister.vue'),
                        navActiveLink: 'admin-tag',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-tag-register-update',
                        component: () => import('@/views/admin/tags/TagRegister.vue'),
                        navActiveLink: 'admin-tag-register',
                    },
                ]
            },

            // CRUD ACRONYMS
            {
                path: '/admin/acronyms',
                name: 'admin-acronyms',
                redirect: '/admin/acronyms/list',
                props: true,
                component: () => import('@/views/admin/acronyms/Acronyms.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-acronyms-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/acronyms/AcronymsList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-acronyms-register',
                        component: () => import('@/views/admin/acronyms/AcronymsRegister.vue'),
                        navActiveLink: 'admin-acronyms',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-acronyms-register-update',
                        component: () => import('@/views/admin/acronyms/AcronymsRegister.vue'),
                        navActiveLink: 'admin-acronyms-register',
                    },
                ]
            },
            // CRUD ACRONYMS
            {
                path: '/admin/adobe-account',
                name: 'admin-adobe-account',
                redirect: '/admin/adobe-account/list',
                props: true,
                component: () => import('@/views/admin/adobe-account/AdobeAccounts.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-adobe-account-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/adobe-account/AdobeAccountsList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-adobe-account-register',
                        component: () => import('@/views/admin/adobe-account/AdobeAccountsRegister.vue'),
                        navActiveLink: 'admin-adobe-account',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-adobe-account-register-update',
                        component: () => import('@/views/admin/adobe-account/AdobeAccountsRegister.vue'),
                        navActiveLink: 'adobe-account-register',
                    },
                ]
            },

            // CRUD ORIGINS
            {
                path: '/admin/origin',
                name: 'admin-origin',
                redirect: '/admin/origin/list',
                props: true,
                component: () => import('@/views/admin/origins/Origin.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-origin-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/origins/OriginList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-origin-register',
                        component: () => import('@/views/admin/origins/OriginRegister.vue'),
                        navActiveLink: 'admin-origin',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-origin-register-update',
                        component: () => import('@/views/admin/origins/OriginRegister.vue'),
                        navActiveLink: 'admin-origin-register',
                    },
                ]
            },

            // CRUD SIGA INSTANCES
            {
                path: '/admin/siga-instance',
                name: 'admin-siga-instance',
                redirect: '/admin/siga-instance/list',
                props: true,
                component: () => import('@/views/admin/siga-instances/SigaInstance.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-siga-instance-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/siga-instances/SigaInstanceList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-siga-instance-register',
                        component: () => import('@/views/admin/siga-instances/SigaInstanceRegister.vue'),
                        navActiveLink: 'admin-siga-instance',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-siga-instance-register-update',
                        component: () => import('@/views/admin/siga-instances/SigaInstanceRegister.vue'),
                        navActiveLink: 'admin-siga-instance-register',
                    },
                ]
            },

            // SUBSCRIBERS
            {
                path: '/admin/subscribers',
                name: 'admin-subscribers',
                redirect: '/admin/subscribers/list',
                props: true,
                component: () => import('@/views/admin/subscribers/Subscribers.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-subscribers-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/subscribers/SubscribersList.vue'),
                    }
                ]
            },

            // CONTACT
            {
                path: '/admin/contact',
                name: 'admin-contact',
                redirect: '/admin/contact/list',
                props: true,
                component: () => import('@/views/admin/contact/Contact.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-contact-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/contact/ContactList.vue'),
                    }
                ]
            },

            // CRUD PUSH CONFIG
            {
                path: '/admin/push-config',
                name: 'admin-push-config',
                redirect: '/admin/push-config/list',
                props: true,
                component: () => import('@/views/admin/push-config/PushConfig.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-push-config-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/push-config/PushConfigList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-push-config-register',
                        component: () => import('@/views/admin/push-config/PushConfigRegister.vue'),
                        navActiveLink: 'admin-tag',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-push-config-register-update',
                        component: () => import('@/views/admin/push-config/PushConfigRegister.vue'),
                        navActiveLink: 'admin-push-config-register',
                    },
                ]
            },

            // CRUD HATS
            {
                path: '/admin/hat',
                name: 'admin-hat',
                redirect: '/admin/hat/list',
                props: true,
                component: () => import('@/views/admin/hats/Hat.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-hat-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/hats/HatList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-hat-register',
                        component: () => import('@/views/admin/hats/HatRegister.vue'),
                        navActiveLink: 'admin-hat',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-hat-register-update',
                        component: () => import('@/views/admin/hats/HatRegister.vue'),
                        navActiveLink: 'admin-hat-register',
                    },
                ]
            },

            // CRUD PERIODICITY
            {
                path: '/admin/periodicity',
                name: 'admin-periodicity',
                redirect: '/admin/periodicity/list',
                props: true,
                component: () => import('@/views/admin/periodicity/Periodicity.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-periodicity-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/periodicity/PeriodicityList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-periodicity-register',
                        component: () => import('@/views/admin/periodicity/PeriodicityRegister.vue'),
                        navActiveLink: 'admin-periodicity',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-periodicity-register-update',
                        component: () => import('@/views/admin/periodicity/PeriodicityRegister.vue'),
                        navActiveLink: 'admin-periodicity-register',
                    },
                ]
            },

            // CRUD CHARACTERISTIC
            {
                path: '/admin/characteristic',
                name: 'admin-characteristic',
                redirect: '/admin/characteristic/list',
                props: true,
                component: () => import('@/views/admin/characteristic/Characteristic.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-characteristic-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/characteristic/CharacteristicList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-characteristic-register',
                        component: () => import('@/views/admin/characteristic/CharacteristicRegister.vue'),
                        navActiveLink: 'admin-characteristic',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-characteristic-register-update',
                        component: () => import('@/views/admin/characteristic/CharacteristicRegister.vue'),
                        navActiveLink: 'admin-characteristic-register',
                    },
                ]
            },

            // CRUD PACKAGE
            {
                path: '/admin/package',
                name: 'admin-package',
                redirect: '/admin/package/list',
                props: true,
                component: () => import('@/views/admin/package/Package.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-package-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/package/PackageList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-package-register',
                        component: () => import('@/views/admin/package/PackageRegister.vue'),
                        navActiveLink: 'admin-package',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-package-register-update',
                        component: () => import('@/views/admin/package/PackageRegister.vue'),
                        navActiveLink: 'admin-package-register',
                    },
                ]
            },

            // CRUD COUNTRY
            {
                path: '/admin/country',
                name: 'admin-country',
                redirect: '/admin/country/list',
                props: true,
                component: () => import('@/views/admin/country/Country.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-country-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/country/CountryList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-country-register',
                        component: () => import('@/views/admin/country/CountryRegister.vue'),
                        navActiveLink: 'admin-country',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-country-register-update',
                        component: () => import('@/views/admin/country/CountryRegister.vue'),
                        navActiveLink: 'admin-country-register',
                    },
                ]
            },

            // CRUD LANGUAGE
            {
                path: '/admin/language',
                name: 'admin-language',
                redirect: '/admin/language/list',
                props: true,
                component: () => import('@/views/admin/language/Language.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-language-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/language/LanguageList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-language-register',
                        component: () => import('@/views/admin/language/LanguageRegister.vue'),
                        navActiveLink: 'admin-language',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-language-register-update',
                        component: () => import('@/views/admin/language/LanguageRegister.vue'),
                        navActiveLink: 'admin-language-register',
                    },
                ]
            },

            // CRUD CONTENT
            {
                path: '/admin/content',
                name: 'admin-content',
                redirect: '/admin/content/list',
                props: true,
                component: () => import('@/views/admin/content/Content.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-content-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/content/ContentList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-content-register',
                        component: () => import('@/views/admin/content/ContentRegister.vue'),
                        navActiveLink: 'admin-content',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-content-register-update',
                        component: () => import('@/views/admin/content/ContentRegister.vue'),
                        navActiveLink: 'admin-content-register',
                    },
                ]
            },

            // CRUD COMMODITY
            {
                path: '/admin/commodity',
                name: 'admin-commodity',
                redirect: '/admin/commodity/list',
                props: true,
                component: () => import('@/views/admin/commodity/Commodity.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-commodity-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/commodity/CommodityList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-commodity-register',
                        component: () => import('@/views/admin/commodity/CommodityRegister.vue'),
                        navActiveLink: 'admin-commodity',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-commodity-register-update',
                        component: () => import('@/views/admin/commodity/CommodityRegister.vue'),
                        navActiveLink: 'admin-commodity-register',
                    },
                ]
            },

            // CRUD REPORT TYPE
            {
                path: '/admin/reportType',
                name: 'admin-reportType',
                redirect: '/admin/reportType/list',
                props: true,
                component: () => import('@/views/admin/reportType/ReportType.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-reportType-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/reportType/ReportTypeList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-reportType-register',
                        component: () => import('@/views/admin/reportType/ReportTypeRegister.vue'),
                        navActiveLink: 'admin-reportType',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-reportType-register-update',
                        component: () => import('@/views/admin/reportType/ReportTypeRegister.vue'),
                        navActiveLink: 'admin-reportType-register',
                    },
                ]
            },

            // CRUD REPORT TYPE GROUPS
            {
                path: '/admin/reportTypeGroups',
                name: 'admin-reportTypeGroups',
                redirect: '/admin/reportTypeGroups/list',
                props: true,
                component: () => import('@/views/admin/reportTypeGroups/ReportTypeGroups.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-reportTypeGroups-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/reportTypeGroups/ReportTypeGroupsList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-reportTypeGroups-register',
                        component: () => import('@/views/admin/reportTypeGroups/ReportTypeGroupsRegister.vue'),
                        navActiveLink: 'admin-reportTypeGroups',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-reportTypeGroups-register-update',
                        component: () => import('@/views/admin/reportTypeGroups/ReportTypeGroupsRegister.vue'),
                        navActiveLink: 'admin-reportTypeGroups-register',
                    },
                ]
            },

            // CRUD CHANNEL
            {
                path: '/admin/channel',
                name: 'admin-channel',
                redirect: '/admin/channel/list',
                props: true,
                component: () => import('@/views/admin/channel/Channel.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-channel-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/channel/ChannelList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-channel-register',
                        component: () => import('@/views/admin/channel/ChannelRegister.vue'),
                        navActiveLink: 'admin-channel',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-channel-register-update',
                        component: () => import('@/views/admin/channel/ChannelRegister.vue'),
                        navActiveLink: 'admin-channel-register',
                    },
                ]
            },

            // CRUD CONTENT RELEVANCE
            {
                path: '/admin/content-relevance',
                name: 'admin-content-relevance',
                redirect: '/admin/content-relevance/list',
                props: true,
                component: () => import('@/views/admin/content-relevance/ContentRelevance.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-content-relevance-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/content-relevance/ContentRelevanceList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-content-relevance-register',
                        component: () => import('@/views/admin/content-relevance/ContentRelevanceRegister.vue'),
                        navActiveLink: 'admin-content-relevance',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-content-relevance-register-update',
                        component: () => import('@/views/admin/content-relevance/ContentRelevanceRegister.vue'),
                        navActiveLink: 'admin-content-relevance-register',
                    },
                ]
            },

            // CRUD CATEGORY
            {
                path: '/admin/category',
                name: 'admin-category',
                redirect: '/admin/category/list',
                props: true,
                component: () => import('@/views/admin/category/Category.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-category-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/category/CategoryList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-category-register',
                        component: () => import('@/views/admin/category/CategoryRegister.vue'),
                        navActiveLink: 'admin-channel',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-category-register-update',
                        component: () => import('@/views/admin/category/CategoryRegister.vue'),
                        navActiveLink: 'admin-category-register',
                    },
                ]
            },

            // CRUD LOGICAL NUMBER
            {
                path: '/admin/logical-number',
                name: 'admin-logical-number',
                redirect: '/admin/logical-number/list',
                props: true,
                component: () => import('@/views/admin/logical-number/LogicalNumber.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-logical-number-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/logical-number/LogicalNumberList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-logical-number-register',
                        component: () => import('@/views/admin/logical-number/LogicalNumberRegister.vue'),
                        navActiveLink: 'admin-logical-number',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-logical-number-register-update',
                        component: () => import('@/views/admin/logical-number/LogicalNumberRegister.vue'),
                        navActiveLink: 'admin-logical-number-register',
                    },
                ]
            },

            // CRUD CLIENT GROUP
            // {
            //     path: '/admin/client-group',
            //     name: 'admin-client-group',
            //     redirect: '/admin/client-group/list',
            //     props: true,
            //     component: () => import('@/views/admin/client-group/ClientGroup.vue'),
            //     children: [
            //         {
            //             path: 'list',
            //             name: 'admin-client-group-list',
            //             props: route => ({ urlQuery: route.query }),
            //             component: () => import('@/views/admin/client-group/ClientGroupList.vue'),
            //         },
            //         {
            //             path: 'register',
            //             name: 'admin-client-group-register',
            //             component: () => import('@/views/admin/client-group/ClientGroupRegister.vue'),
            //             navActiveLink: 'admin-client-group',
            //         },
            //         {
            //             path: 'register/:id',
            //             name: 'admin-client-group-register-update',
            //             component: () => import('@/views/admin/client-group/ClientGroupRegister.vue'),
            //             navActiveLink: 'admin-client-group-register',
            //         },
            //     ]
            // },

            // CRUD AUDITLOG
            {
                path: '/admin/auditlog',
                name: 'admin-auditlog',
                redirect: '/admin/auditlog/list',
                props: true,
                component: () => import('@/views/admin/auditlog/Auditlog.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-Auditlog-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/auditlog/AuditlogList.vue'),
                    },
                ]
            },

            // CRUD AUTH TOKEN
            {
                path: '/admin/auth-token',
                name: 'admin-auth-token',
                redirect: '/admin/auth-token/list',
                props: true,
                component: () => import('@/views/admin/auth-token/AuthToken.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-auth-token-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/auth-token/AuthTokenList.vue')
                    },
                ]
            },

            // CRUD CLIENT ACCESS
            {
                path: '/admin/client-access',
                name: 'admin-client-access',
                redirect: '/admin/client-access/list',
                props: true,
                component: () => import('@/views/admin/client-access/ClientAccess.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-client-access-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/client-access/ClientAccessList.vue')
                    },
                ]
            },

            // CRUD AUDITLOG
            {
                path: '/admin/ask-analyst',
                name: 'admin-ask-analyst',
                redirect: '/admin/ask-analyst/list',
                props: true,
                component: () => import('@/views/admin/ask-analyst/AskAnalyst.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-ask-analyst-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/ask-analyst/AskAnalystList.vue'),
                    },
                ]
            },

            // CRUD CLIENT SIGNATURE
            {
                path: '/admin/client-signature',
                name: 'admin-client-signature',
                redirect: '/admin/client-signature/list',
                props: true,
                component: () => import('@/views/admin/client-signature/ClientSignature.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-client-signature-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/client-signature/ClientSignatureList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-client-signature-register',
                        component: () => import('@/views/admin/client-signature/ClientSignatureRegister.vue'),
                        navActiveLink: 'admin-client-signature',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-client-signature-register-update',
                        component: () => import('@/views/admin/client-signature/ClientSignatureRegister.vue'),
                        navActiveLink: 'admin-client-signature-register',
                    },
                ]
            },

            // CRUD CONTENT  PRIVATE CONF
            {
                path: '/admin/content-private-conf',
                name: 'admin-content-private-conf',
                redirect: '/admin/content-private-conf/list',
                props: true,
                component: () => import('@/views/admin/content-private-conf/ContentPrivateConf.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-content-private-conf',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/content-private-conf/ContentPrivateConfList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-content-private-conf-register',
                        component: () => import('@/views/admin/content-private-conf/ContentPrivateConfRegister.vue'),
                        navActiveLink: 'admin-content-private-conf',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-content-private-conf-register-update',
                        component: () => import('@/views/admin/content-private-conf/ContentPrivateConfRegister.vue'),
                        navActiveLink: 'admin-content-private-conf-register',
                    },
                ]
            },

            // CRUD SUBJECT TAG SEARCH
            {
                path: '/admin/topic',
                name: 'admin-topic',
                redirect: '/admin/topic/list',
                props: true,
                component: () => import('@/views/admin/topic/Topic.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-topic',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/topic/TopicList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-topic-register',
                        component: () => import('@/views/admin/topic/TopicRegister.vue'),
                        navActiveLink: 'admin-topic',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-topic-register-update',
                        component: () => import('@/views/admin/topic/TopicRegister.vue'),
                        navActiveLink: 'admin-topic-register',
                    },
                ]
            },

            // CRUD SENDMAIL
            {
                path: '/admin/sendmail',
                name: 'admin-sendmail',
                redirect: '/admin/sendmail/list',
                props: true,
                component: () => import('@/views/admin/sendmail/Sendmail.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-sendmail',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/sendmail/SendmailList.vue'),
                    },
                ]
            },

            // CRUD SENDPUSH
            {
                path: '/admin/sendpush',
                name: 'admin-sendpush',
                redirect: '/admin/sendpush/list',
                props: true,
                component: () => import('@/views/admin/sendpush/Sendpush.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-sendpush',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/sendpush/SendpushList.vue'),
                    },
                ]
            },

            // CRUD DEMOREQUEST
            {
                path: '/admin/demo-request',
                name: 'admin-demo-request',
                redirect: '/admin/demo-request/list',
                props: true,
                component: () => import('@/views/admin/demo-request/DemoRequest.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-demo-request',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/demo-request/DemoRequestList.vue'),
                    },
                ]
            },

            // CRUD LEADS
            {
                path: '/admin/leads',
                name: 'admin-leads',
                redirect: '/admin/leads/list',
                props: true,
                component: () => import('@/views/admin/send-lead/SendLead.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-leads',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/send-lead/SendLeadList.vue'),
                    },
                ]
            },

            // CRUD DELETED CLIENTS
            {
                path: '/admin/deleted-client',
                name: 'admin-deleted-client',
                redirect: '/admin/deleted-client/list',
                props: true,
                component: () => import('@/views/admin/deleted-client/DeletedClient.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-deleted-client',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/deleted-client/DeletedClientList.vue'),
                    },
                ]
            },

            // CRUD ASSETS ACTIVE
            {
                path: '/admin/asset-reference',
                name: 'admin-asset-reference',
                redirect: '/admin/asset-reference/list',
                props: true,
                component: () => import('@/views/admin/asset-reference/AssetReference.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-asset-reference-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/asset-reference/AssetReferenceList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-asset-reference-register',
                        component: () => import('@/views/admin/asset-reference/AssetReferenceRegister.vue'),
                        navActiveLink: 'admin-asset-reference',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-asset-reference-register-update',
                        component: () => import('@/views/admin/asset-reference/AssetReferenceRegister.vue'),
                        navActiveLink: 'admin-asset-reference-register',
                    },
                ]
            },

            // CRUD USER CORE
            {
                path: '/admin/user-core',
                name: 'admin-user-core',
                redirect: '/admin/user-core/list',
                props: true,
                component: () => import('@/views/admin/user-core/UserCore.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-user-core-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/user-core/UserCoreList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-user-core-register',
                        component: () => import('@/views/admin/user-core/UserCoreRegister.vue'),
                        navActiveLink: 'admin-user-core',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-user-core-register-update',
                        component: () => import('@/views/admin/user-core/UserCoreRegister.vue'),
                        navActiveLink: 'admin-user-core-register',
                    },
                ]
            },

            // CRUD LAYOUT
            {
                path: '/admin/layout',
                name: 'admin-layout',
                redirect: '/admin/layout/list',
                props: true,
                component: () => import('@/views/admin/layout/Layout.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-layout-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/layout/LayoutList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-layout-register',
                        component: () => import('@/views/admin/layout/LayoutRegister.vue'),
                        navActiveLink: 'admin-layout',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-layout-register-update',
                        component: () => import('@/views/admin/layout/LayoutRegister.vue'),
                        navActiveLink: 'admin-layout-register',
                    },
                ]
            },

            // CRUD LAYOUT WDMA HIST
            {
                path: '/admin/layout-wdma-hist',
                name: 'admin-layout-wdma-hist',
                redirect: '/admin/layout-wdma-hist/list',
                props: true,
                component: () => import('@/views/admin/layout-wdma-hist/LayoutWdmaHist.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-layout-wdma-hist-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/layout-wdma-hist/LayoutWdmaHistList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-layout-wdma-hist-register',
                        component: () => import('@/views/admin/layout-wdma-hist/LayoutWdmaHistRegister.vue'),
                        navActiveLink: 'admin-layout-wdma-hist',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-layout-wdma-hist-register-update',
                        component: () => import('@/views/admin/layout-wdma-hist/LayoutWdmaHistRegister.vue'),
                        navActiveLink: 'admin-layout-wdma-hist-register',
                    },
                ]
            },

            // CRUD GEOLOCATION
            {
                path: '/admin/geolocation',
                name: 'admin-geolocation',
                redirect: '/admin/geolocation/list',
                props: true,
                component: () => import('@/views/admin/geolocation/Geolocation.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-geolocation-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/geolocation/GeolocationList.vue')
                    },
                ]
            },

            // CRUD MDTP PROVIDER STATUS
            {
                path: '/admin/mdtp-provider-status',
                name: 'admin-mdtp-provider-status',
                redirect: '/admin/mdtp-provider-status/list',
                props: true,
                component: () => import('@/views/admin/mdtp-provider-status/MdtpProviderStatus.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-mdtp-provider-status-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/mdtp-provider-status/MdtpProviderStatusList.vue')
                    },
                ]
            },

            // CRUD SERVICE ACCESS MANAGER
            {
                path: '/admin/service-access-manager',
                name: 'admin-service-access-manager',
                redirect: '/admin/service-access-manager/list',
                props: true,
                component: () => import('@/views/admin/service-access-manager/ServiceAccessManager.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-service-access-manager-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/service-access-manager/ServiceAccessManagerList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-service-access-manager-register',
                        component: () => import('@/views/admin/service-access-manager/ServiceAccessManagerRegister.vue'),
                        navActiveLink: 'admin-service-access-manager',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-service-access-manager-register-update',
                        component: () => import('@/views/admin/service-access-manager/ServiceAccessManagerRegister.vue'),
                        navActiveLink: 'admin-service-access-manager-register',
                    },
                ]
            },

            // CRUD ACCEPTOR LOGS
            {
                path: '/admin/acceptor-logs',
                name: 'admin-acceptor-logs',
                redirect: '/admin/acceptor-logs/list',
                props: true,
                component: () => import('@/views/admin/acceptor-logs/AcceptorLogs.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-acceptor-logs-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/acceptor-logs/AcceptorLogsList.vue'),
                    }
                ]
            },

            // CRUD APP CONFIG RULES
            {
                path: '/admin/app-config-rules',
                name: 'admin-app-config-rules',
                redirect: '/admin/app-config-rules/list',
                props: true,
                component: () => import('@/views/admin/app-config-rules/AppConfigRules.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-app-config-rules-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/app-config-rules/AppConfigRulesList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-app-config-rules-register',
                        component: () => import('@/views/admin/app-config-rules/AppConfigRulesRegister.vue'),
                        navActiveLink: 'admin-app-config-rules',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-app-config-rules-register-update',
                        component: () => import('@/views/admin/app-config-rules/AppConfigRulesRegister.vue'),
                        navActiveLink: 'admin-app-config-rules-register',
                    },
                ]
            },

            // CRUD VECTORIZATION MANAGEMENT
            {
                path: '/admin/vectorization-management',
                name: 'admin-vectorization-management',
                redirect: '/admin/vectorization-management/list',
                props: true,
                component: () => import('@/views/admin/vectorization-management/VectorizationManagement.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-vectorization-management-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/vectorization-management/VectorizationManagementList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-vectorization-management-register',
                        component: () => import('@/views/admin/vectorization-management/VectorizationManagementRegister.vue'),
                        navActiveLink: 'admin-vectorization-management',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-vectorization-management-register-update',
                        component: () => import('@/views/admin/vectorization-management/VectorizationManagementRegister.vue'),
                        navActiveLink: 'admin-vectorization-management-register',
                    },
                ]
            },

            // CRUD INSTITUTION
            {
                path: '/admin/institution',
                name: 'admin-institution',
                redirect: '/admin/institution/list',
                props: true,
                component: () => import('@/views/admin/institutions/Institution.vue'),
                children: [
                    {
                        path: 'list',
                        name: 'admin-institution-list',
                        props: route => ({ urlQuery: route.query }),
                        component: () => import('@/views/admin/institutions/InstitutionList.vue'),
                    },
                    {
                        path: 'register',
                        name: 'admin-institution-register',
                        component: () => import('@/views/admin/institutions/InstitutionRegister.vue'),
                        navActiveLink: 'admin-institution',
                    },
                    {
                        path: 'register/:id',
                        name: 'admin-institution-register-update',
                        component: () => import('@/views/admin/institutions/InstitutionRegister.vue'),
                        navActiveLink: 'admin-institution-register',
                    },
                ]
            },

        ]
    },

]
